import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { Filter } from "@shared/interfaces";
import { Hospital } from "@shared/models";

import { UpdateHospitalPermissionPayload } from "../interfaces";

export default {
  getHospitals: (payload: Filter) => request(METHODS.GET, API.HOSPIATAL.GET_HOSPIATALS)({ params: payload }),
  getHospital: (id: string) => request(METHODS.GET, API.HOSPIATAL.GET_HOSPIATAL(id))(),
  getHospitalFormsSettings: (id: string) => request(METHODS.GET, API.HOSPIATAL.GET_HOSPIATAL_FORMS_SETTINGS(id))(),
  getHospitalPermissions: (id: string) => request(METHODS.GET, API.HOSPIATAL.GET_HOSPIATAL_PERMISSIONS(id))(),
  updateHospitalPermissions: (payload: UpdateHospitalPermissionPayload) => {
    const { id, permission_id, ...rest } = payload;
    return request(METHODS.PUT, API.HOSPIATAL.UPDATE_HOSPIATAL_PERMISSION(String(id), String(permission_id)))(rest);
  },
  updateHospital: (payload: Partial<Hospital>) => {
    const { id, ...rest } = payload;
    return request(METHODS.PATCH, API.HOSPIATAL.UPDATE_HOSPIATAL(String(id)))(rest);
  },
};
